import { Link } from "react-router-dom";
import { Check } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Logo } from "@/components/AuthShell";
import { ContactForm } from "@/components/ContactForm";
import { useAuth } from "@/context/AuthContext";
import { Hero } from "@/components/landing/Hero";
import { Audience } from "@/components/landing/Audience";
import { Features, RmmSection } from "@/components/landing/Features";
import { Showcase } from "@/components/landing/Showcase";
import { Compare } from "@/components/landing/Compare";
import { Pricing } from "@/components/landing/Pricing";
import { Steps, Security, Faq } from "@/components/landing/Closing";
import { Demo, UseCases } from "@/components/landing/Demo";

const NAV = [["presentation", "Présentation"], ["demo", "Démo"], ["fonctionnalites", "Fonctionnalités"], ["rmm", "Supervision"], ["comparatif", "Comparatif"], ["tarifs", "Tarifs"], ["contact", "Contact"]];

const Header = () => {
  const { user } = useAuth();
  return (
    <header className="sticky top-0 z-30 backdrop-blur-md bg-[#090D16]/85 border-b border-slate-800/70">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 h-16 flex items-center justify-between gap-2">
        <Logo />
        <nav className="flex items-center gap-1">
          {NAV.map(([id, l]) => <a key={id} href={`#${id}`} className="hidden lg:inline px-2 py-2 text-sm font-bold text-slate-200 hover:text-white transition-colors" data-testid={`nav-${id}`}>{l}</a>)}
          <Link to="/join" className="hidden sm:inline px-2 py-2 text-sm font-bold text-sky-300 hover:text-white transition-colors" data-testid="nav-join">Rejoindre une session</Link>
          {user ? (
            <Button asChild className="rounded-full"><Link to="/app" data-testid="landing-dashboard-btn">Tableau de bord</Link></Button>
          ) : (
            <>
              <Button asChild variant="ghost" className="px-3 font-bold hover:bg-slate-800 hover:text-white"><Link to="/login" data-testid="landing-login-btn">Connexion</Link></Button>
              <Button asChild className="rounded-full font-bold"><Link to="/register" data-testid="landing-register-btn">Essai gratuit</Link></Button>
            </>
          )}
        </nav>
      </div>
    </header>
  );
};

const Contact = () => (
  <section className="border-t border-slate-800/70" id="contact">
    <div className="max-w-7xl mx-auto px-6 py-20 lg:py-28 grid lg:grid-cols-[1fr_1.1fr] gap-12 items-start">
      <div>
        <p className="font-mono text-xs tracking-[0.2em] text-sky-400 mb-3">CONTACT</p>
        <h2 className="text-2xl sm:text-3xl lg:text-4xl font-extrabold tracking-tight mb-4">Une question ? Parlons-en.</h2>
        <p className="text-slate-400 leading-relaxed mb-6">Essai, migration depuis un autre outil, déploiement sur votre parc : écrivez-nous, nous vous répondons rapidement par email.</p>
        <ul className="space-y-3 text-sm text-slate-400">
          {["Réponse par un humain, pas un robot", "Accompagnement à l'installation des agents", "Aide à la migration depuis TeamViewer, AnyDesk ou un autre outil"].map((t) => (
            <li key={t} className="flex gap-2.5"><Check className="h-4 w-4 text-sky-400 mt-0.5" />{t}</li>
          ))}
        </ul>
      </div>
      <ContactForm />
    </div>
  </section>
);

export default function Landing() {
  return (
    <div className="min-h-screen bg-[#090D16] text-slate-100">
      <Header />
      <Hero />
      <Audience />
      <Demo />
      <Features />
      <Showcase />
      <RmmSection />
      <Compare />
      <UseCases />
      <Steps />
      <Pricing />
      <Security />
      <Faq />
      <Contact />
      <footer className="border-t border-slate-800 py-8 text-center text-xs text-slate-500">© {new Date().getFullYear()} ScreenView — Prise en main à distance et supervision de parc PC, Mac & Linux</footer>
    </div>
  );
}
